module.exports = __webpack_public_path__ + "static/Thumb_MM_S11_compass_MM-dedb91d47533776ddbc4ddb21a72e303.png";